/**
 * Operating Access Constants for Admin Frontend
 * Defines the types of operating hours access
 */

export const OPERATING_ACCESS_TYPES = {
  '24_7': '24_7',
  DAILY: 'daily',
  VARIES: 'varies',
  RESTRICTED: 'restricted',
  CLOSED: 'closed'
} as const;

export type OperatingAccessType = typeof OPERATING_ACCESS_TYPES[keyof typeof OPERATING_ACCESS_TYPES];

// Operating access options for select dropdown
export const OPERATING_ACCESS_OPTIONS = [
  { id: '24_7', name: 'resources.sites.operatingAccess.24_7' },
  { id: 'daily', name: 'resources.sites.operatingAccess.daily' },
  { id: 'varies', name: 'resources.sites.operatingAccess.varies' },
  { id: 'restricted', name: 'resources.sites.operatingAccess.restricted' },
  { id: 'closed', name: 'resources.sites.operatingAccess.closed' }
];

// Default operating access type
export const DEFAULT_OPERATING_ACCESS = '24_7';